import React from 'react'

import { ReactComponent as EyeOff } from '../../../../assets/svgs/eye-off.svg'

export const EyeOffIcon = ({ width = 24, height = 24, ...restProps }) => (
  <EyeOff
    width={width}
    height={height}
    aria-hidden="true"
    focusable="false"
    {...restProps}
  />
)
